import { useCallback, useMemo } from 'react';
import { useLocalStorage } from '@frontend/web-storage';
import { LocationServiceLocationItem, LocationServiceRecentLocation } from '../types/location.types';

export const LOCATION_HISTORY_STORAGE_KEY = 'wam-location-service__location-history';

export const useLocationHistory = () => {
  const [value, setState] = useLocalStorage<LocationServiceRecentLocation[]>({
    key: LOCATION_HISTORY_STORAGE_KEY,
    defaultValue: [],
  });

  const locations = useMemo(() => value || [], [value]);

  const removeLocation = useCallback(
    (locationId: string) => {
      const updatedLocations = locations.filter((location) => location.locationId !== locationId);
      setState(updatedLocations);
    },
    [locations]
  );

  const addLocation = useCallback(
    ({ locationId, name = locationId }: LocationServiceLocationItem) => {
      if (isLatestLocation(locationId)) {
        return;
      }

      const updatedLocations = [
        { locationId, name, created: Date.now() },
        ...locations.filter((l) => l.locationId !== locationId),
      ].slice(0, 20);

      setState(updatedLocations);
    },
    [locations]
  );

  const isLatestLocation = useCallback(
    (locationId: string) => {
      return locations[0]?.locationId === locationId;
    },
    [locations]
  );

  return { locations, addLocation, removeLocation, isLatestLocation };
};
